var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCodSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "500px",
    height: "500px",
    viewBox: "0 0 500 500",
    enableBackground: "new 0 0 500 500",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    width: 499.998,
    height: 500
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#333333"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M224.803,450.357c-14.496,0-29.002-5.451-40.131-16.418L16.988,268.514c-22.43-22.135-22.674-58.39-0.57-80.851 L135.874,66.63c22.136-22.44,58.4-22.685,80.841-0.569l60.455,59.651l-20.152,20.427l-60.444-59.672 c-11.169-10.986-29.236-10.884-40.273,0.305L36.845,207.804c-11.027,11.189-10.905,29.256,0.285,40.264l167.664,165.465 c11.2,11.008,29.267,10.865,40.282-0.305l119.466-121.074c11.006-11.168,10.885-29.234-0.295-40.242l-49.51-48.869l20.141-20.406 l49.521,48.848c22.398,22.094,22.654,58.391,0.549,80.792L265.49,433.371C254.332,444.703,239.562,450.357,224.803,450.357z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M201.518,114.502c0,12.654-10.284,22.929-22.949,22.929s-22.939-10.274-22.939-22.929 c0-12.695,10.274-22.949,22.939-22.949S201.518,101.807,201.518,114.502z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.386,378.316c0,12.695-10.274,22.949-22.939,22.949s-22.929-10.254-22.929-22.949c0-12.676,10.264-22.93,22.929-22.93 S247.386,365.641,247.386,378.316z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.802,268.779c-15.869,25.572-43.66,37.027-62.052,25.613c-18.392-11.453-20.417-41.422-4.537-66.997 c15.889-25.533,43.681-37.007,62.052-25.593C248.657,213.257,250.68,243.246,234.802,268.779z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 475.146,
    y: 201.253,
    width: 24.852,
    height: 142.659
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.971,125.956c-25.816-26.754-52.57-13.387-52.57-13.387l-77.434,37.313c-16.194,11.454,1.902,36.031,1.902,36.031 c12.43,16.947,51.625-10.233,51.625-10.233l1.018,0.712c17.762-9.989,40.791-7.345,55.531,8.016l47.344,49.276 c17.486,18.229,16.896,47.405-1.283,64.881l-35.705,45.348l0,0h80.303V200.541L386.971,125.956z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodSmall);
export default __webpack_public_path__ + "static/media/cod-small.a0fbd086142f2d2b8b04ce1cc73478f6.svg";
export { ForwardRef as ReactComponent };